<div class="surface-card p-4 shadow-2 border-round">
  <ng-template [ngIf]="isLoadingResults">
    <app-loading></app-loading>
</ng-template>
    <div class="mb-3 flex md:flex-row align-items-center md:justify-content-between justify-content-between ">
      <div class="flex justify-start md:justify-start">
        <span *ngIf="!isPresidioTIM && filterIsSet && filtroPratica" class="text-xl font-medium text-2000 font-['Poppins']" style="color: #6c092c">PRATICA <b>{{filtroPratica}}</b> CON SOPRALLUOGO <i>KO</i></span>

        <span *ngIf="!isPresidioTIM && !filterIsSet" class="text-xl font-medium text-2000 font-['Poppins']" style="color: #6c092c">PRATICHE DEL <b>BANDO 2</b> in <i>KO</i></span>
        <span *ngIf="!isPresidioTIM && filtroInLavorazione" class="text-xl font-medium text-2000 font-['Poppins']" style="color: #6c092c">PRATICHE DEL <b>BANDO 2</b> <i>KO</i> IN LAVORAZIONE</span>

        <span *ngIf="isPresidioTIM"class="text-xl font-medium text-2000 font-['Poppins']" style="color: #6c092c">PRATICHE DEL <b>BANDO 2</b> <i>KO</i> IN CARICO AL PRESIDIO</span>
        <span *ngIf="!isPresidioTIM && filterIsSet && filtroLotto"  class="text-xl font-medium text-2000 font-['Poppins']" style="color: #6c092c">PRATICHE DEL <b>BANDO 2</b> <i>KO</i> E LOTTO <i>{{filtroLotto}}</i></span>
        <span *ngIf="!isPresidioTIM && filterIsSet && !filtroLotto && filtroStatoInfratel && !filtroLottoPerFase"  class="text-xl font-medium text-2000 font-['Poppins']" style="color: #6c092c">PRATICHE DEL <b>BANDO 2</b> <i>KO</i> E STATO <i>{{filtroStatoInfratel}}</i></span>
        <span *ngIf="!isPresidioTIM && filterIsSet && filtroStatoInfratel && filtroLottoPerFase"  class="text-xl font-medium text-2000 font-['Poppins']" style="color: #6c092c">PRATICHE DEL <b>BANDO 2</b> <i>KO</i> E STATO <i>{{filtroStatoInfratel}}</i> E LOTTO  <i>{{filtroLottoPerFase}}</i></span>
        <span *ngIf="!isPresidioTIM && filterIsSet && filtroOda"  class="text-xl font-medium text-2000 font-['Poppins']" style="color: #6c092c">PRATICHE DEL <b>BANDO 2</b> <i>KO</i> E ODA  <i>{{filtroOda}}</i></span>

          
         
      </div>
      <div class="flex justify-end md:justify-center">
      </div>
       
      <div class="flex justify-end md:justify-end">
        <button *ngIf="!isPM && !isImpresa"
          pButton type="button" 
          pTooltip="Importa pratiche vincolate" tooltipPosition="top"
          class="font-['Poppins'] mr-3"
          style="background-color:#a1d4d5; color: #0e192d; border-color: #223f41; font-size: 13px;"
          label="Importa KO"
          (click)="importaPraticheVincolate()" [disabled]="isLoadingResults || isDemo"
        >
        <i class="material-symbols-outlined">
          fence
      </i></button>
       <button *ngIf="praticheFiltrate && praticheFiltrate.length > 0"
          pButton type="button" icon="pi pi-cloud-download"
          pTooltip="Scarica export" tooltipPosition="top"
          class="font-['Poppins'] mr-3"
          style="background-color:#e3faf8; color: #0e192d; border-color: #3d64b3; font-size: 13px;"
          label="Scarica report"
          (click)="scaricaReportPraticheKO()" [disabled]="isLoadingResults"
        ></button> 
        </div>
    </div>
 
 <!--[sortField]="'numero'" [sortOrder]="1"-->
            <div fxFlex="95%" class="mt-2">
                <p-table #praticheDT styleClass="p-datatable-sm" [value]="praticheFiltrate" dataKey="id" [(selection)]="selectedPratica"
                [selectionPageOnly]="true" [rowHover]="true" [rows]="50" [showCurrentPageReport]="true"
                [rowsPerPageOptions]="[50,100,200]" responsiveLayout="scroll" [paginator]="true"
                currentPageReportTemplate="{first} - {last} di {totalRecords}" [filterDelay]="0"
                [sortField]="'vincoloCategoriaCodice'" [sortOrder]="1"
                [globalFilterFields]="['cui','vincoloFase','vincoloCategoriaCodice','codiceInvio','bando','tipoSede','tipoSedeEffettiva','denominazione','regione','comune','codiceMiur','azienda', 'lotto','numeroOda','statoFlowdyFase3','codiceStatoInfratelFase3']"
                >
                <ng-template pTemplate="caption">
                  <div class="flex align-items-center md:justify-content-between justify-content-between ">
                  
                    <div class="flex justify-start md:justify-start" style="align-items: stretch;">
                      <span class="p-input-icon-left mr-2">
                        <i class="pi pi-search"></i>
                        <input type="text" pInputText placeholder="Cerca" (input)="filtraPratiche($event)" [disabled]="isLoadingResults" style="height: 2.5rem;" />
                      </span>
                      <p-multiSelect 
                        *ngIf="!filterIsSet "
                        styleClass="fieldFilterControl" 
                        [options]="imprese"
                        [showToggleAll]="false"
                        optionLabel="ragioneSociale"
                        optionValue="id"
                        (onChange)="filtraPratiche($event)"
                        placeholder="Impresa"
                        [showClear]="false"
                        [filter]="false"
                        [showHeader]="false"
                        [(ngModel)]="filtroPratiche.impresa"
                      />
                      <p-multiSelect 
                        *ngIf="!filterIsSet"
                        styleClass="ml-2 fieldFilterControl" 
                        [options]="listeService.opzioniTipoSedeBando1"
                        [showToggleAll]="false"
                        optionLabel="label"
                        optionValue="value"
                        (onChange)="filtraPratiche($event)"
                        placeholder="Tipo sede"
                        [showClear]="false"
                        [filter]="false"
                        [showHeader]="false"
                        [(ngModel)]="filtroPratiche.tipo"
                      />
                     
                      <p-multiSelect 
                        *ngIf="!filterIsSet"
                        styleClass="ml-2 fieldFilterControl" 
                        [options]="listeService.opzioniRegioniBando1"
                        [showToggleAll]="false"
                        optionLabel="label"
                        optionValue="value"
                        (onChange)="filtraPratiche($event)"
                        placeholder="Regione"
                        [showClear]="false"
                        [filter]="false"
                        [showHeader]="false"
                        [(ngModel)]="filtroPratiche.regione"
                      />
                      <!--    [options]="listeService.opzioniCausaKO" -->
                      <p-multiSelect 
                        *ngIf="!filterIsSet "
                        styleClass="ml-2 fieldFilterControl" 
                        [options]="listeService.fasiVincolo"
                        [showToggleAll]="false"
                        [optionLabel]="label"
                        optionValue="value"
                        (onChange)="filtraPratiche($event)"
                        placeholder="Fase Vincolo"
                        [showClear]="false"
                        [filter]="false"
                        [showHeader]="false"
                        [(ngModel)]="filtroPratiche.faseVincolo"
                      />
                      <p-multiSelect 
                        *ngIf="!filterIsSet "
                        styleClass="ml-2 fieldFilterControl" 
                        [options]="listeService.tipologieVincolo"
                        [showToggleAll]="false"
                        [optionLabel]="label"
                        [optionValue]="id"
                        (onChange)="filtraPratiche($event)"
                        placeholder="Tipo Vincolo"
                        [showClear]="false"
                        [filter]="false"
                        [showHeader]="false"
                        [(ngModel)]="filtroPratiche.tipoVincolo"
                      />
                      <p-multiSelect 
                        *ngIf="!filterIsSet "
                        styleClass="ml-2 fieldFilterControl" 
                        [options]="categorieVincolo"
                        [showToggleAll]="false"
                        [optionLabel]="label"
                        optionValue="codice"
                        (onChange)="filtraPratiche($event)"
                        placeholder="Categoria Vincolo"
                        [showClear]="false"
                        [filter]="false"
                        [showHeader]="false"
                        [(ngModel)]="filtroPratiche.categoriaVincolo"
                      />
                     <!--  <p-multiSelect 
                        *ngIf="!filterIsSet && !isImpresa"
                        styleClass="ml-2 fieldFilterControl" 
                        [options]="listeService.opzioniVincoloKO"
                        [showToggleAll]="false"
                        optionLabel="label"
                        optionValue="value"
                        (onChange)="filtraPratiche($event)"
                        placeholder="Vincolo"
                        [showClear]="false"
                        [filter]="false"
                        [showHeader]="false"
                        [(ngModel)]="filtroPratiche.vincoloKO"
                      /> -->
                      <button *ngIf="filterIsSet || filterTabellaIsSet" pButton type="button" icon="pi pi-filter-slash" class="ml-2"
                        style="background-color: #809cd4; border-color:#191a1b; color: #f9f9f9;font-size: 13px;" (click)="removeFilter()"
                        pTooltip="Rimuovi filtro" tooltipPosition="top" 
                      ></button>
                    </div>
                    <div class="flex justify-end md:justify-center">
                    </div>
                   
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                  <tr>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 3%;">Azioni</th> 
                    <th pSortableColumn="cui" style="font-size: 10px; width: 13%;">
                        CUI
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 3%;">
                      FASE 
                  </th>
                    <th class="text-center font-['Poppins']" pSortableColumn="causaSopralluogoKO" style="font-size: 9px; width: 8%;">
                      TIPO VINCOLO
                     </th> 
                    <th class="text-center font-['Poppins']" pSortableColumn="causaSopralluogoKO" style="font-size: 9px; width: 12%;">
                     CATEGORIA VINCOLO
                    </th> 
                   
                   <!--  <th class="text-center font-['Poppins']" pSortableColumn="causaSopralluogoKO" style="font-size: 10px; width: 10%;">
                      VINCOLO
                    </th>  -->
                   
                  <!--   <th class="text-center font-['Poppins']" pSortableColumn="tipoVincolo" style="font-size: 10px; width: 10%;">
                      TIPO VINCOLO
                    </th>  -->
                    <th  pSortableColumn="denominazione" style="font-size: 10px; width: 15%;">
                      SCUOLA
                    </th>
                    <th  pSortableColumn="denominazione" style="font-size: 10px; width: 7%;">
                      COMUNE
                    </th>
                    <th *ngIf="!isImpresa" class="text-center font-['Poppins']" style="font-size: 10px;width: 10%;">
                      IMPRESA
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;">
                        LOTTO
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;">
                      ODA
                    </th>
                    
                  
                    <th  pSortableColumn="tipoSedeEffettiva" class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;">
                      TIPO
                   </th>
               
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;">
                      DATA SOPRALLUOGO
                    </th>
                   <!--  <th class="text-center font-['Poppins']" style="font-size: 10px; width: 3%;">
                      APPROVATO
                    </th> -->
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-row>
                    <tr>
                      <tr>
                        <td class="text-center" style="width: 10px;">
                           <button 
                             pButton type="button" style="color:rgb(39, 128, 15)"
                             icon="pi pi-ellipsis-v" class="p-button-rounded p-button-text" 
                             (click)="openCaricaAzioni($event,row)">
                           </button> 
                         </td> 
                      <td > 
                        <span class="text-uppercase font-semibold font-['Poppins']" style="font-size: 9px; "
                        [pTooltip]="row.codiceMiur"
                        tooltipPosition="top">{{row.cui}}</span> 
                      </td>
                      <td class="text-center font-['Poppins']"> 
                        <p-tag *ngIf="row.vincoloFase || row.vincoloFase === 0" [value]="row.vincoloFase"
                              [style]="{
                                'background-color': stiliService.getColoreFaseKO(row.vincoloFase) ,
                                'color': '#ffffff' ,
                                'border-radius': '6px',
                                'padding': '.25em .5rem',
                                'font-weight': '700',
                                'font-size': '10px',
                                'letter-spacing': '.3px;',
                              }"
                                  class="mr-1"
                                 
                        ></p-tag>
                      </td>
                      <td class="text-center font-['Poppins']"> 
                        <p-tag *ngIf="row.vincoloTipologiaLabel" [value]="row.vincoloTipologiaLabel.toUpperCase()"
                              [style]="{
                                'background-color': stiliService.getColoreCategoriaVincoloKO(row.vincoloTipologiaID) ,
                                'color': '#ffffff' ,
                                'border-radius': '6px',
                                'padding': '.25em .5rem',
                                'font-weight': '700',
                                'font-size': '9.5px',
                                'letter-spacing': '.3px;',
                              }"
                                  class="mr-1"
                                 
                        ></p-tag>
                      </td>
                      <td class="text-center font-['Poppins']"> 
                        <p-tag *ngIf="row.vincoloCategoriaLabel" [value]="row.vincoloCategoriaLabel.toUpperCase()"
                              [style]="{
                                'background-color': stiliService.getColoreCategoriaVincoloKO(row.vincoloTipologiaID) ,
                                'color': '#ffffff' ,
                                'border-radius': '6px',
                                'padding': '.25em .5rem',
                                'font-weight': '700',
                                'font-size': '10px',
                                'letter-spacing': '.3px;',
                              }"
                                  class="mr-1"
                                  [pTooltip]="row.vincoloCategoriaLabel"
                                  tooltipPosition="top"
                        ></p-tag>
                      </td>
                    
                     <!--  <td class="text-center font-['Poppins']"> 
                        <p-tag *ngIf="row.vincoloCategoriaCodice" [value]="row.vincoloCategoriaCodice.toUpperCase()"
                              [style]="{
                                'background-color': stiliService.getColoreCausaKO(row.vincoloCategoriaCodice) ,
                                'color': '#ffffff' ,
                                'border-radius': '6px',
                                'padding': '.25em .5rem',
                                'font-weight': '700',
                                'font-size': '10px',
                                'letter-spacing': '.3px;',
                              }"
                                  class="mr-1"
                                  [pTooltip]="row.vincoloCategoriaCodice"
                                  tooltipPosition="top"
                        ></p-tag>
                      </td> -->
                     <!--  <td class="text-center font-['Poppins']"> 
                        <p-tag *ngIf="row.causaSopralluogoKO" [value]="row.causaSopralluogoKO.toUpperCase()"
                              [style]="{
                                'background-color': stiliService.getColoreCausaKO(row.causaSopralluogoKO) ,
                                'color': '#ffffff' ,
                                'border-radius': '6px',
                                'padding': '.25em .5rem',
                                'font-weight': '700',
                                'font-size': '10px',
                                'letter-spacing': '.3px;',
                              }"
                                  class="mr-1"
                                  [pTooltip]="row.noteSopralluogo"
                                  tooltipPosition="top"
                        ></p-tag>
                      </td> -->
                      <!-- <td class="text-center font-['Poppins']"> 
                        <p-tag *ngIf="row.vincolata && row.tipoVincolo" [value]="row.tipoVincolo.toUpperCase()"
                              [style]="{
                                'background-color': stiliService.getColoreVincoloKO(row.tipoVincolo) ,
                                'color': '#ffffff' ,
                                'border-radius': '6px',
                                'padding': '.25em .5rem',
                                'font-weight': '500',
                                'font-size': '9px',
                                'letter-spacing': '.3px;',
                              }"
                                  class="mr-1"
                                  [pTooltip]="row.noteVincolo"
                                  tooltipPosition="top"
                        ></p-tag>
                      </td> -->
                      <td > 
                        <span class="text-uppercase font-['Poppins']" style="font-weight: 500;font-size: 10px; "
                          [pTooltip]="row.indirizzo"
                          tooltipPosition="top"
                          >{{row.denominazione}}</span> 
                      </td>
                      <td > 
                        <span class="text-uppercase font-['Poppins']" style="font-weight: 500;font-size: 10px; "
                        [pTooltip]="row.regione.toUpperCase()"
                          tooltipPosition="top"
                          >{{row.comune.toUpperCase()}}</span> 
                      </td>
                      <td *ngIf="!isImpresa" class="text-center font-['Poppins']"> 
                        <p-tag
                                [value]="row.azienda | uppercase"
                                [style]="{
                                  'background-color': '#326F6F' ,
                                  'color': '#ffffff' ,
                                  'border-radius': '6px',
                                  'padding': '.25em .5rem',
                                  'font-weight': '700',
                                  'font-size': '8px',
                                  'letter-spacing': '.2px;',
                                  'cursor': 'pointer',
                                }"
                                 (click)="filtraPerAzienda(row.azienda)"
                                 [pTooltip]="filterIsSet?'ELimina filtro':'Filtra per azienda '+ row.azienda"
                                  tooltipPosition="top"
                            ></p-tag>
                       </td>
                    
                      <td class="text-center font-['Poppins']"> 
                        <p-tag [value]="row.lotto | uppercase"
                              [style]="{
                                'background-color': '#EBC66B' ,
                                'color': '#ffffff' ,
                                'border-radius': '6px',
                                'padding': '.25em .5rem',
                                'font-weight': '700',
                                'font-size': '9px',
                                'letter-spacing': '.3px;',
                                'cursor': 'pointer',
                              }"
                                  class="mr-1"
                                  (click)="filtraPerLotto(row.lotto)"
                                  [pTooltip]="filterIsSet?'ELimina filtro':'Filtra per lotto '+row.lotto"
                                  tooltipPosition="top"
                        ></p-tag>
                      </td>
                      <td class="text-center font-['Poppins']"> 
                        <p-tag *ngIf="row.numeroOda" [value]="row.numeroOda"
                              [style]="{
                                'background-color': '#78C0E0' ,
                                'color': '#ffffff' ,
                                'border-radius': '6px',
                                'padding': '.25em .5rem',
                                'font-weight': '700',
                                'font-size': '10px',
                                'letter-spacing': '.3px;',
                                'cursor': 'pointer',
                              }"
                                  class="mr-1"
                                  (click)="filtraPerOda(row.numeroOda)"
                                  [pTooltip]="filterIsSet?'ELimina filtro':'Filtra su ODA #'+row.numeroOda"
                                  tooltipPosition="top"
                        ></p-tag>
                      </td>
                     
                    
                      <td *ngIf="row.tipoSede === row.tipoSedeEffettiva" class="text-center"> <span class="text-uppercase" style="font-weight: bold; font-size: 10px;">{{row.tipoSede}}</span> </td>
                      <td *ngIf="row.tipoSede !== row.tipoSedeEffettiva" class="text-center"> <span class="text-uppercase" style="font-weight: bold; font-size: 10px;">{{row.tipoSede}} ({{row.tipoSedeEffettiva}})</span> </td>
 
                      
                    
                     
                        <td class="text-center font-['Poppins']">
                            <span *ngIf="row.dataUltimaModificaFase1" 
                            class="text-center text-uppercase font-semibold font-['Poppins']" 
                            style="font-size: 11px; " 
                            [pTooltip]="row.noteSopralluogo"
                            tooltipPosition="top"
                                      >{{utilService.formattaDataDaTimestampFirestore(row.dataUltimaModificaFase1)}}
                          </span>  
                        </td> 
                     <!--    <td class="text-center font-['Poppins']">
                          <span *ngIf="row.sopralluogoApprovato"
                          class="material-symbols-outlined small-icon"
                          [ngClass]="'check'"
                          [ngStyle]="{ 'color': '#00A878' }"
                          >
                          {{ 'check' }}
                          </span>
                        </td>  -->
                      </tr>
                </ng-template>
              </p-table> 
              <p-tieredMenu #menuAzioniTiered [popup]="true" [model]="menuAzioniItems"></p-tieredMenu>
            </div>
		</div>
   
    <p-dialog [(visible)]="showRendiLavorabile" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '60vw'}" [closable]="false" [showHeader]="false">
      <div class="flex flex-column align-items-center my-4">
        <span class="flex align-items-center justify-content-center bg-green-100 text-green-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
          <i class="material-symbols-outlined small-icon" >published_with_changes</i>
        </span>
          <!--  <div class="font-medium text-2xl text-900">RENDI LAVORABILE</div> -->
      </div>
      <p class="line-height-3 p-0 mb-2 text-center">
          Confermi di voler rendere nuovamente <strong>LAVORABILE</strong> la pratica <span style="font-weight: bold;">{{selectedPratica?selectedPratica.cui:''}}</span>?
      </p>
      <p class="line-height-3 p-1 text-center surface-100 border-round" style="background-color: #f8f9fa;" *ngIf="selectedPratica && selectedPratica.vincoloFase === 2">
        Trattandosi di VINCOLO di <strong>FASE 2</strong>, ricordati di sbloccare la pratica anche nella sezione <i>Pronto Fibra</i>
      </p>
      <ng-template pTemplate="footer">
          <div class="border-top-1 surface-border pt-2 flex">
              <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showRendiLavorabile = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
              <button pButton pRipple icon="pi pi-check" style="background-color: #4CAF50; border-color: #4CAF50; color: white;" (click)="confermaRendiPraticaLavorabile()" label="CONFERMA" class="w-6 ml-2"></button>
          </div>
      </ng-template>
  </p-dialog> 
  
<p-toast position="top-center"></p-toast>
<p-confirmDialog></p-confirmDialog>